'use strict';

// v = 2.0

import dispatcher from '../dispatcher';
import {EventEmitter} from '../utils';

const eventEmitter = new EventEmitter();

let initialized = false;

let transitionType = false;

let historyEmitted = false;
let href = false;

let loadAnimation = 'start-complete';

let loaded = false;
let content = false;

let timer;

let allProgress = 0;
let components = {
  // scrl: {
  //   progress: 0
  // }
};
let time = 200;


function isLoaded() {
  clearTimeout(timer);

  let tmpProgress = 0;

  if (Object.keys(components).length > 0) {
    for (let key in components) {
      tmpProgress += (100 / Object.keys(components).length / 100 * components[key].progress);
    }
  } else {
    tmpProgress = 100;
  }

  // allProgress = Math.round(tmpProgress);
  allProgress = tmpProgress;

  eventEmitter.dispatch(_getData('loading-progress'));

  if (allProgress >= 100) {
    timer = setTimeout(function () {
      eventEmitter.dispatch(_getData('components-loaded'));
    }, time);

    // time = 100;
  }
}

function _handleEvent(e) {

  switch (e.type) {
    // case ('template-complete') : {
    //   components = {...components, ...e.components}
    //   break
    // }
    case ('load-start') : {
      loaded = false;
      content = null;
      transitionType = e.transitionType;
      historyEmitted = e.history;
      href = e.href;

      allProgress = 0;
      for (let key in components) {
        if (!components[key].once) components[key].progress = 0;
      }

      eventEmitter.dispatch(_getData('loading'));
      break;
    }
    case ('load-end') :
      loaded = true;
      content = e.content;
      eventEmitter.dispatch(_getData('loaded'));
      break;

    case ('load-animation') :
      loadAnimation = e.data;

      eventEmitter.dispatch(_getData('load-animation-play'));

      if (e.data === 'start-complete') isLoaded();
      break;

    case ('component-load') :
      components[e.data].progress = e.progress;

      isLoaded();
      break;
  }
}

function _init() {
  dispatcher.subscribe(_handleEvent);
  initialized = true;
}
  

function _getData(type) {
  return {
    type: type,
    _module: 'loader.store',
    transitionType: transitionType,
    historyEmitted: historyEmitted,
    href: href,
    loadAnimation: loadAnimation,
    loaded: loaded,
    content: content,
    progress: allProgress
  };
}

if (!initialized) _init();

export default {
  eventEmitter: eventEmitter,
  getData: _getData.bind(null, undefined) // карринг, ёпте))
}